/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_CustomerType_SelectCustomerType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/CustomerType/SelectCustomerType */ "./resources/scripts/components/CustomerType/SelectCustomerType.ts");
/* harmony import */ var _scripts_components_CartUpsellSlider_CartUpsellSlider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/CartUpsellSlider/CartUpsellSlider */ "./resources/scripts/components/CartUpsellSlider/CartUpsellSlider.ts");
/* harmony import */ var _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/Bundle/Bundle */ "./resources/scripts/components/Bundle/Bundle.ts");
/* harmony import */ var _scripts_components_AskAboutTabs_AskAboutTabs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/AskAboutTabs/AskAboutTabs */ "./resources/scripts/components/AskAboutTabs/AskAboutTabs.ts");






var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
consent.init();
customElements.define('ask-about-tabs', _scripts_components_AskAboutTabs_AskAboutTabs__WEBPACK_IMPORTED_MODULE_5__["default"]);
customElements.define('cart-upsell-slider', _scripts_components_CartUpsellSlider_CartUpsellSlider__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define('geolocator-component', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('select-customer-type', _scripts_components_CustomerType_SelectCustomerType__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('bundle-component', _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_4__["default"]);

/***/ }),

/***/ "./resources/scripts/components/AskAboutTabs/AskAboutTabs.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/AskAboutTabs/AskAboutTabs.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AskAboutTabs)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AskAboutTabs = /*#__PURE__*/function (_HTMLElement) {
  function AskAboutTabs() {
    var _this;
    _classCallCheck(this, AskAboutTabs);
    _this = _callSuper(this, AskAboutTabs);
    _defineProperty(_this, "ask_about_tabcontent_1", void 0);
    _defineProperty(_this, "ask_about_tabcontent_2", void 0);
    _defineProperty(_this, "ask_about_tablink_1", void 0);
    _defineProperty(_this, "ask_about_tablink_2", void 0);
    _this.OpenTab = _this.OpenTab.bind(_this);
    return _this;
  }
  _inherits(AskAboutTabs, _HTMLElement);
  return _createClass(AskAboutTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.ask_about_tablink_1 = this.querySelector('#ask_about_tablink_1');
      this.ask_about_tablink_2 = this.querySelector('#ask_about_tablink_2');
      this.ask_about_tabcontent_1 = this.querySelector('#ask_about_tabcontent_1');
      this.ask_about_tabcontent_2 = this.querySelector('#ask_about_tabcontent_2');
      this.ask_about_tablink_1.addEventListener('click', function (e) {
        return _this2.OpenTab(e, 'ask_about_tabcontent_1');
      });
      this.ask_about_tablink_2.addEventListener('click', function (e) {
        return _this2.OpenTab(e, 'ask_about_tabcontent_2');
      });
      this.OpenTab(new MouseEvent('click'), 'ask_about_tabcontent_1');
    }
  }, {
    key: "OpenTab",
    value: function OpenTab(evt, tabName) {
      this.ask_about_tabcontent_1.style.display = 'none';
      this.ask_about_tabcontent_2.style.display = 'none';
      this.ask_about_tablink_1.classList.remove('active');
      this.ask_about_tablink_2.classList.remove('active');
      if (tabName === 'ask_about_tabcontent_1') {
        this.ask_about_tabcontent_1.style.display = 'block';
        this.ask_about_tablink_1.classList.add('active');
      } else if (tabName === 'ask_about_tabcontent_2') {
        this.ask_about_tabcontent_2.style.display = 'block';
        this.ask_about_tablink_2.classList.add('active');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Bundle/Bundle.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Bundle/Bundle.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BundleComponent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable prefer-template */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
/* eslint-disable no-console */
var BundleComponent = /*#__PURE__*/function (_HTMLElement) {
  function BundleComponent() {
    var _this;
    _classCallCheck(this, BundleComponent);
    _this = _callSuper(this, BundleComponent);
    _defineProperty(_this, "addToCartButton", _this.closest('.product').querySelector('product-form').querySelector('button[type="submit"]'));
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "loadingOverlay", _this.querySelector('.loading-overlay'));
    _this.initEventListeners = _this.initEventListeners.bind(_this);
    _this.handleAddBundleToCart = _this.handleAddBundleToCart.bind(_this);
    _this.addVariantToCart = _this.addVariantToCart.bind(_this);
    _this.getJwtToken = _this.getJwtToken.bind(_this);
    _this.isTokenExpired = _this.isTokenExpired.bind(_this);
    _this.decodeJwtToken = _this.decodeJwtToken.bind(_this);
    _this.refreshJwtToken = _this.refreshJwtToken.bind(_this);
    _this.toggleCartDrawer = _this.toggleCartDrawer.bind(_this);
    return _this;
  }
  _inherits(BundleComponent, _HTMLElement);
  return _createClass(BundleComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initElement();
      this.initEventListeners();
    }
  }, {
    key: "initElement",
    value: function initElement() {
      this.addToCartButton.disabled = false;
      var text = this.addToCartButton.querySelector('.single-add-to-cart-button--text');
      if (text) {
        text.textContent = 'Tilføj til kurv';
      }
    }
  }, {
    key: "initEventListeners",
    value: function initEventListeners() {
      var _this2 = this;
      this.addToCartButton.addEventListener('click', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                _context.n = 1;
                return _this2.handleAddBundleToCart();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    // eslint-disable-next-line consistent-return
  }, {
    key: "handleAddBundleToCart",
    value: function () {
      var _handleAddBundleToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var shop, token, bundleComponents, metaobjectId, productId, body, response, refreshedToken, retryResponse, data, bundle, message, variant, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.loadingOverlay.style.display = 'flex';
              shop = window.Shopify.shop;
              _context2.n = 1;
              return this.getJwtToken(shop);
            case 1:
              token = _context2.v;
              // Get the JWT token (or refresh if expired)
              // bundle components is a string like "1,2,3". We need to convert it to an array.
              bundleComponents = this.getAttribute('data-bundlecomponents').split(',') || [];
              metaobjectId = this.getAttribute('data-metaobjectid');
              productId = this.getAttribute('data-productid');
              body = {
                productId: productId,
                bundleComponents: bundleComponents,
                metaobjectId: metaobjectId,
                shop: shop
              };
              console.log('Adding bundle to cart with body:', body);
              _context2.n = 2;
              return fetch('http://bundle-app.edition.dk/api/bundle', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(token) // Use the JWT token
                },
                body: JSON.stringify(body)
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 8;
                break;
              }
              if (!(response.status === 401)) {
                _context2.n = 7;
                break;
              }
              // Token expired or unauthorized
              console.log('Token expired. Attempting to refresh token...');
              _context2.n = 3;
              return this.getJwtToken(window.Shopify.shop);
            case 3:
              refreshedToken = _context2.v;
              _context2.n = 4;
              return fetch('http://bundle-app.edition.dk/api/bundle', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(refreshedToken)
                },
                body: JSON.stringify(body)
              });
            case 4:
              retryResponse = _context2.v;
              if (retryResponse.ok) {
                _context2.n = 5;
                break;
              }
              throw new Error('Failed to add bundle to cart');
            case 5:
              _context2.n = 6;
              return retryResponse.json();
            case 6:
              return _context2.a(2, _context2.v);
            case 7:
              throw new Error('Failed to add bundle to cart');
            case 8:
              _context2.n = 9;
              return response.json();
            case 9:
              data = _context2.v;
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              bundle = data.bundle, message = data.message, variant = data.variant;
              _context2.n = 10;
              return this.addVariantToCart(variant);
            case 10:
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t = _context2.v;
              console.error('Error adding bundle to cart:', _t);
            case 12:
              _context2.p = 12;
              this.loadingOverlay.style.display = 'none';
              return _context2.f(12);
            case 13:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 11, 12, 13]]);
      }));
      function handleAddBundleToCart() {
        return _handleAddBundleToCart.apply(this, arguments);
      }
      return handleAddBundleToCart;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "toggleCartDrawer",
    value: function toggleCartDrawer() {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      var cartDrawerToggle = document.getElementById('cart-drawer-toggle');
      if (cartDrawerToggle) {
        cartDrawerToggle.click();
      }
    }
  }, {
    key: "getSectionsToRender",
    value: function getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      }, {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      }, {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(variant) {
        var _this3 = this;
        var items, response, data, pollForVariant, interval, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              items = [{
                id: variant,
                quantity: 1
              }];
              _context4.p = 1;
              _context4.n = 2;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: items,
                  sections: this.getSectionsToRender().map(function (section) {
                    return section.section;
                  }),
                  sections_url: window.location.pathname
                })
              });
            case 2:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 3;
                break;
              }
              throw new Error('Failed to add variant to cart');
            case 3:
              _context4.n = 4;
              return response.json();
            case 4:
              data = _context4.v;
              // Because the variant we added to cart might be a variant that was just created, it might not just yet be available for the liquid api.
              // therefor we need to poll the product until it is available.
              // once it is we refresh the cart drawer
              pollForVariant = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var pollingResponse, _yield$pollingRespons, variants, _t2;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.p = _context3.n) {
                      case 0:
                        _context3.p = 0;
                        _context3.n = 1;
                        return fetch("".concat(_this3.productUrl, ".json"));
                      case 1:
                        pollingResponse = _context3.v;
                        if (pollingResponse.ok) {
                          _context3.n = 2;
                          break;
                        }
                        throw new Error('Network response was not ok');
                      case 2:
                        _context3.n = 3;
                        return pollingResponse.json();
                      case 3:
                        _yield$pollingRespons = _context3.v;
                        variants = _yield$pollingRespons.product.variants;
                        if (variants.some(function (_variant) {
                          return _variant.id === Number(variant);
                        })) {
                          // eslint-disable-next-line @typescript-eslint/no-use-before-define
                          clearInterval(interval); // Stop polling when the variant is found
                          _this3.renderContents(data);
                          _this3.loadingOverlay.style.display = 'none';
                        }
                        _context3.n = 5;
                        break;
                      case 4:
                        _context3.p = 4;
                        _t2 = _context3.v;
                        console.error('Error polling for variant:', _t2);
                      case 5:
                        return _context3.a(2);
                    }
                  }, _callee3, null, [[0, 4]]);
                }));
                return function pollForVariant() {
                  return _ref2.apply(this, arguments);
                };
              }();
              interval = setInterval(pollForVariant, 1500);
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t3 = _context4.v;
              console.error(_t3);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 5]]);
      }));
      function addVariantToCart(_x2) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
  }, {
    key: "getSectionInnerHTML",
    value: function getSectionInnerHTML(html) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }, {
    key: "renderContents",
    value: function renderContents(parsedState) {
      var _this4 = this;
      this.getSectionsToRender().forEach(function (section) {
        if (!document.getElementById(section.id)) {
          return;
        }
        console.log("Rendering section: ".concat(section.id, " with selector: ").concat(section.selector));
        console.log('Element to replace:', document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id));
        var elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = _this4.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      });
      var productDrawer = document.getElementById('Product-Modal');
      if (productDrawer && productDrawer.contains(this)) {
        productDrawer.hide();
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
  }, {
    key: "getJwtToken",
    value: function () {
      var _getJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(shop) {
        var token, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              token = localStorage.getItem('jwtTokenBundle'); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context5.n = 2;
                break;
              }
              console.log('Token expired or missing. Getting a new token...');
              _context5.n = 1;
              return this.refreshJwtToken(shop);
            case 1:
              token = _context5.v;
            case 2:
              return _context5.a(2, token);
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              console.error('Failed to get JWT token', _t4);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function getJwtToken(_x3) {
        return _getJwtToken.apply(this, arguments);
      }
      return getJwtToken;
    }() // Check if the token is expired
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // Decode JWT token (you can use any JWT library here)
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Failed to decode JWT token', e);
        return null;
      }
    }
    // Refresh the JWT token
  }, {
    key: "refreshJwtToken",
    value: function () {
      var _refreshJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shop) {
        var response, data, jwtToken;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return fetch('http://bundle-app.edition.dk/api/auth', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 1:
              response = _context6.v;
              if (response.ok) {
                _context6.n = 2;
                break;
              }
              throw new Error('Failed to refresh token');
            case 2:
              _context6.n = 3;
              return response.json();
            case 3:
              data = _context6.v;
              jwtToken = data.token;
              localStorage.setItem('jwtTokenBundle', jwtToken);
              return _context6.a(2, jwtToken);
          }
        }, _callee6);
      }));
      function refreshJwtToken(_x4) {
        return _refreshJwtToken.apply(this, arguments);
      }
      return refreshJwtToken;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/CartUpsellSlider/CartUpsellSlider.ts":
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/CartUpsellSlider/CartUpsellSlider.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartUpsellSlider)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CartUpsellSlider = /*#__PURE__*/function (_HTMLElement) {
  function CartUpsellSlider() {
    var _this;
    _classCallCheck(this, CartUpsellSlider);
    _this = _callSuper(this, CartUpsellSlider);
    _defineProperty(_this, "upsell_btn_left", void 0);
    _defineProperty(_this, "upsell_btn_right", void 0);
    _defineProperty(_this, "upsell_slider_container", void 0);
    _defineProperty(_this, "upsell_slide", void 0);
    _this.upsell_btn_left = _this.querySelector('.upsell_btn_left');
    _this.upsell_btn_right = _this.querySelector('.upsell_btn_right');
    _this.upsell_slider_container = _this.querySelector('.upsell_slider_container');
    _this.upsell_slide = _this.querySelector('.upsell_slide');
    _this.moveLeft = _this.moveLeft.bind(_this);
    _this.moveRight = _this.moveRight.bind(_this);
    return _this;
  }
  _inherits(CartUpsellSlider, _HTMLElement);
  return _createClass(CartUpsellSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.upsell_btn_left.addEventListener('click', function () {
        if (!_this2.upsell_btn_left.classList.contains('disabled')) {
          _this2.moveLeft();
        }
      });
      this.upsell_btn_right.addEventListener('click', function () {
        if (!_this2.upsell_btn_right.classList.contains('disabled')) {
          _this2.moveRight();
        }
      });
      if (this.upsell_slider_container) {
        this.upsell_slider_container.addEventListener('scroll', function () {
          _this2.updateButtonStates();
        });
      }
      this.updateButtonStates();
    }
  }, {
    key: "updateButtonStates",
    value: function updateButtonStates() {
      if (!this.upsell_slider_container || !this.upsell_slide) {
        return;
      }
      var container = this.upsell_slider_container;
      var scrollLeft = container.scrollLeft;
      var scrollWidth = container.scrollWidth;
      var clientWidth = container.clientWidth;
      var isAtStart = scrollLeft <= 1;
      var isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      if (this.upsell_btn_left) {
        if (isAtStart) {
          this.upsell_btn_left.classList.add('disabled');
        } else {
          this.upsell_btn_left.classList.remove('disabled');
        }
      }
      if (this.upsell_btn_right) {
        if (isAtEnd) {
          this.upsell_btn_right.classList.add('disabled');
        } else {
          this.upsell_btn_right.classList.remove('disabled');
        }
      }
    }
  }, {
    key: "moveLeft",
    value: function moveLeft() {
      if (this.upsell_slider_container && this.upsell_btn_left && !this.upsell_btn_left.classList.contains('disabled')) {
        this.upsell_slider_container.scrollLeft -= this.upsell_slide.offsetWidth + 24;
      }
    }
  }, {
    key: "moveRight",
    value: function moveRight() {
      if (this.upsell_slider_container && this.upsell_btn_right && !this.upsell_btn_right.classList.contains('disabled')) {
        this.upsell_slider_container.scrollLeft += this.upsell_slide.offsetWidth + 24;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// - Ensure GDPR/CCPA compliance by providing legally required opt-in/opt-out functionality and transparency.
// - Refer to Shopify's privacy documentation for specific implementation requirements.
//
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
    this.logConsent = this.logConsent.bind(this);
  }
  // methods
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1'
              }], function (error) {
                if (error) {
                  console.error('Error loading features: ', error);
                  return;
                }
                console.log('Consent tracking API loaded');
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener('visitorConsentCollected', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate('update');
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById('recall-consent');
              if (recallConsentElement) {
                recallConsentElement.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
                analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                wait_for_update: 3000
              };
              this.gtag('consent', state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem('consentSettings', JSON.stringify(consent));
              this.logConsent(consent);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }() /* eslint-disable */)
  }, {
    key: "logConsent",
    value: (function () {
      var _logConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(consentSettings) {
        var _localStorage$getItem, userId, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              if (!((_localStorage$getItem = localStorage.getItem('userId')) !== null && _localStorage$getItem !== void 0)) {
                _context7.n = 1;
                break;
              }
              _t = _localStorage$getItem;
              _context7.n = 3;
              break;
            case 1:
              _context7.n = 2;
              return this.generateRandomHash();
            case 2:
              _t = _context7.v;
            case 3:
              userId = _t;
              localStorage.setItem('userId', userId);
              /* TODO: Add endpoint to log the users preferences for more compliance
                const logData = {
                user: USER_HERE,
                consentSettings,
                }
                       const response = await fetch('https://my-url/api/my-endpoint', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                });
                       if (!response.ok) {
                  throw new Error('Failed to log consent');
                }
                       const data = await response.json();
                console.log('Consent logged successfully: ', data);
                       COMMENT FOR ENDPOINT + DATABASE
                       When this event is recieved in the endpoint, the backend should first look at the website the request is coming from.
                If the request is coming from a website that is not allowed in our database, the request should be denied.
                This is to prevent unauthorized websites from logging consent settings, and to only allow websites that use our services to log consent settings.
                       After verifying the website, the backend should log the user's consent settings to a database
                If the user does not exist in the database, create a new entry for the user with the consent settings
                If the user exists in the database, update the user's consent settings with the new values
                       Database strucutre should be relational and could look like this:
                Each user / visitor belongs to a shop, and each shop can have multiple users / visitors
                Each user / visitor can have multiple consent settings
                       model: Shop
                       id | name | url | created_at | updated_at | user[]
                ---------------------------------------------------
                1  | Shop1| url1| 2021-09-01 | 2021-09-01 | [User1, User2, User3]
                       model: User
                       User | Functionality | Analytics | Personalization | Ad Storage | Ad User Data | Ad Personalization | created_at | updated_at | shop_id
                -------------------------------------------------------------------------------------------------------
                User1|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User2|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User3|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User4|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User5|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User6|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
              */
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t2 = _context7.v;
              console.error('Error logging consent: ', _t2);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 4]]);
      }));
      function logConsent(_x2) {
        return _logConsent.apply(this, arguments);
      }
      return logConsent;
    }())
  }, {
    key: "generateRandomHash",
    value: function () {
      var _generateRandomHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var randomHash;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              randomHash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              return _context8.a(2, randomHash);
          }
        }, _callee8);
      }));
      function generateRandomHash() {
        return _generateRandomHash.apply(this, arguments);
      }
      return generateRandomHash;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/CustomerType/SelectCustomerType.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/CustomerType/SelectCustomerType.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SelectCustomerType)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SelectCustomerType = /*#__PURE__*/function (_HTMLElement) {
  function SelectCustomerType() {
    var _this;
    _classCallCheck(this, SelectCustomerType);
    _this = _callSuper(this, SelectCustomerType);
    _defineProperty(_this, "cvrValidated", false);
    _defineProperty(_this, "form", void 0);
    _defineProperty(_this, "checkoutButton", void 0);
    _defineProperty(_this, "customerType", void 0);
    _defineProperty(_this, "customerTypeSelected", void 0);
    _defineProperty(_this, "customerPopover", void 0);
    _defineProperty(_this, "customerPopoverSelection", void 0);
    _defineProperty(_this, "customerPopoverB2b", void 0);
    _defineProperty(_this, "customerPopoverGov", void 0);
    _defineProperty(_this, "customerTypeButtons", void 0);
    _defineProperty(_this, "changeCustomerTypeButton", void 0);
    _defineProperty(_this, "changeCustomerTypeButtonText", void 0);
    _defineProperty(_this, "closePopoverButtons", void 0);
    _defineProperty(_this, "eanSubmitButton", void 0);
    _defineProperty(_this, "cvrSubmitButton", void 0);
    _defineProperty(_this, "sessionStorageCustomerData", void 0);
    _defineProperty(_this, "eanInput", void 0);
    _defineProperty(_this, "cvrInput", void 0);
    _defineProperty(_this, "emailInput", void 0);
    _defineProperty(_this, "customerCustomerType", void 0);
    _defineProperty(_this, "customerCvrNumber", void 0);
    _defineProperty(_this, "customerEanNumber", void 0);
    _defineProperty(_this, "customerEmail", void 0);
    _defineProperty(_this, "cartDrawer", void 0);
    _this.initElements = _this.initElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.togglePopoverOverlay = _this.togglePopoverOverlay.bind(_this);
    _this.togglePopoverContent = _this.togglePopoverContent.bind(_this);
    _this.handleCustomerTypeSelection = _this.handleCustomerTypeSelection.bind(_this);
    _this.handleTogglePopoverContent = _this.handleTogglePopoverContent.bind(_this);
    _this.handleCheckoutButtonClicked = _this.handleCheckoutButtonClicked.bind(_this);
    _this.updateCartInfo = _this.updateCartInfo.bind(_this);
    _this.handleEanSubmit = _this.handleEanSubmit.bind(_this);
    _this.handleCvrSubmit = _this.handleCvrSubmit.bind(_this);
    _this.handleCvrInputChange = _this.handleCvrInputChange.bind(_this);
    _this.closeAllPopovers = _this.closeAllPopovers.bind(_this);
    _this.initData = _this.initData.bind(_this);
    return _this;
  }
  _inherits(SelectCustomerType, _HTMLElement);
  return _createClass(SelectCustomerType, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initData();
      this.initElements();
      this.addEventListeners();
      if (this.customerTypeSelected && this.customerType !== 'null') {
        this.changeCustomerTypeButton.classList.remove('tw-hidden');
        this.changeCustomerTypeButton.textContent = "".concat(this.changeCustomerTypeButtonText, " (").concat(this.customerType, ")");
      }
    }
  }, {
    key: "initData",
    value: function initData() {
      this.customerCustomerType = this.dataset.customertype || null;
      this.customerCvrNumber = this.dataset.cvrnumber || null;
      this.customerEanNumber = this.dataset.eannumber || null;
      this.customerEmail = this.dataset.email || null;
      if (this.customerCvrNumber || this.customerEanNumber || this.customerEmail) {
        var customerTypeSelected = this.customerCustomerType || sessionStorage.getItem('customerType');
        sessionStorage.setItem('customerType', customerTypeSelected);
        sessionStorage.setItem('customerData', JSON.stringify({
          cvrNumber: this.customerCvrNumber,
          eanNumber: this.customerEanNumber,
          email: this.customerEmail
        }));
      }
      this.customerType = sessionStorage.getItem('customerType') || null;
      this.customerTypeSelected = this.customerType !== null;
      this.sessionStorageCustomerData = sessionStorage.getItem('customerData') || null;
    }
  }, {
    key: "initElements",
    value: function initElements() {
      this.form = this.querySelector('form');
      this.checkoutButton = this.form.querySelector('button[type="submit"]');
      this.customerPopover = document.getElementById('customer-type-popover');
      this.customerPopoverSelection = this.customerPopover.querySelector('#customer-type-popover-content');
      this.customerTypeButtons = Array.from(this.customerPopover.querySelectorAll('.customer-type-button'));
      this.changeCustomerTypeButton = this.querySelector('#change-customer-type');
      this.changeCustomerTypeButtonText = this.changeCustomerTypeButton.textContent;
      this.customerPopoverB2b = this.customerPopover.querySelector('#customer-type-popover-b2b');
      this.customerPopoverGov = this.customerPopover.querySelector('#customer-type-popover-gov');
      this.closePopoverButtons = Array.from(this.customerPopover.querySelectorAll('.close-popover'));
      // Ean elements - government
      this.eanSubmitButton = this.customerPopover.querySelector('#ean-submit');
      this.eanInput = this.customerPopover.querySelector('#ean-input');
      var existingCustomerData = this.sessionStorageCustomerData ? JSON.parse(this.sessionStorageCustomerData) : {};
      if (existingCustomerData.eanNumber) {
        this.eanInput.value = existingCustomerData.eanNumber;
      }
      // cvr+ email - b2b
      this.cvrSubmitButton = this.customerPopover.querySelector('#cvr-submit');
      this.cvrInput = this.customerPopover.querySelector('#cvr-input');
      this.emailInput = this.customerPopover.querySelector('#email-input');
      if (existingCustomerData.cvrNumber) {
        this.cvrInput.value = existingCustomerData.cvrNumber;
      }
      if (existingCustomerData.email) {
        this.emailInput.value = existingCustomerData.email;
      }
      var customerType = sessionStorage.getItem('customerType');
      if (customerType) {
        var stylesheet = document.createElement('style');
        stylesheet.innerHTML = "\n        .exemptify_button {\n          display: none !important;\n        }\n      ";
        document.head.appendChild(stylesheet);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.checkoutButton.addEventListener('click', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                _context.n = 1;
                return _this2.handleCheckoutButtonClicked();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.customerTypeButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleCustomerTypeSelection(button);
        });
      });
      this.changeCustomerTypeButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.togglePopoverOverlay();
        _this2.togglePopoverContent(_this2.customerPopoverSelection);
        console.log('Change customer type button clicked');
      });
      this.closePopoverButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleTogglePopoverContent();
        });
      });
      this.eanSubmitButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.handleEanSubmit();
      });
      this.cvrSubmitButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.handleCvrSubmit();
      });
      // Add real-time error message management for CVR input
      this.cvrInput.addEventListener('input', function (event) {
        _this2.handleCvrInputChange(event);
      });
      // Add Enter key support for CVR input
      this.cvrInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          _this2.handleCvrSubmit();
        }
      });
      // Add Enter key support for email input
      this.emailInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          _this2.handleCvrSubmit();
        }
      });
      // Add Enter key support for EAN input
      this.eanInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          _this2.handleEanSubmit();
        }
      });
    }
  }, {
    key: "togglePopoverOverlay",
    value: function togglePopoverOverlay() {
      this.customerPopover.classList.toggle('active');
    }
  }, {
    key: "togglePopoverContent",
    value: function togglePopoverContent(popoverElement) {
      // Close all popovers before opening the new one
      var allPopovers = this.customerPopover.querySelectorAll('.customer-popover-element');
      allPopovers.forEach(function (popover) {
        return popover.classList.remove('active');
      });
      // Now activate the selected popover
      popoverElement.classList.add('active');
    }
  }, {
    key: "handleCustomerTypeSelection",
    value: function handleCustomerTypeSelection(button) {
      // Ensure all previous popovers are closed before toggling the new content
      this.closeAllPopovers();
      // Now set the customer type and update the popover display
      this.customerType = button.dataset.option;
      sessionStorage.setItem('customerType', this.customerType);
      // Clear any existing customer data when changing customer type
      sessionStorage.removeItem('customerData');
      this.changeCustomerTypeButton.classList.remove('tw-hidden');
      this.changeCustomerTypeButton.textContent = "".concat(this.changeCustomerTypeButtonText, " (").concat(this.customerType, ")");
      this.togglePopoverOverlay();
      // Show the appropriate content based on customer type
      if (this.customerType === 'b2b') {
        this.togglePopoverContent(this.customerPopoverB2b);
      } else if (this.customerType === 'gov') {
        this.togglePopoverContent(this.customerPopoverGov);
      } else if (this.customerType === 'b2c') {
        // For B2C, update cart info and proceed to checkout
        this.handleB2cSelection();
      } else {
        this.togglePopoverContent(this.customerPopoverSelection);
      }
    }
  }, {
    key: "handleB2cSelection",
    value: function () {
      var _handleB2cSelection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              // Clear any existing customer data for B2C
              sessionStorage.removeItem('customerData');
              sessionStorage.setItem('customerData', JSON.stringify({
                cvrNumber: '',
                email: '',
                eanNumber: ''
              }));
              _context6.p = 1;
              _context6.n = 2;
              return this.updateCartInfo();
            case 2:
              this.closeAllPopovers();
              if (this.checkTermsAccepted()) {
                window.location.href = '/checkout';
              }
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleB2cSelection() {
        return _handleB2cSelection.apply(this, arguments);
      }
      return handleB2cSelection;
    }()
  }, {
    key: "handleTogglePopoverContent",
    value: function handleTogglePopoverContent() {
      // First, close all open popovers
      var activePopover = this.customerPopover.querySelector('.customer-popover-element.active');
      if (activePopover) {
        activePopover.classList.remove('active');
      }
      // Now, toggle the overlay and content
      var selectionPopoverIsOpen = this.customerPopoverSelection.classList.contains('active');
      var b2bPopoverIsOpen = this.customerPopoverB2b.classList.contains('active');
      var govPopoverIsOpen = this.customerPopoverGov.classList.contains('active');
      if (selectionPopoverIsOpen) {
        this.togglePopoverOverlay();
      }
      if (b2bPopoverIsOpen || govPopoverIsOpen) {
        this.togglePopoverContent(this.customerPopoverSelection);
      }
      // Close the active popover and reset
      this.togglePopoverOverlay();
    }
  }, {
    key: "checkTermsAccepted",
    value: function checkTermsAccepted() {
      var cartDrawer = this.closest('cart-drawer');
      var cart = this.closest('theme-cart');
      var termsAccepted = false;
      if (cartDrawer) {
        termsAccepted = cartDrawer.querySelector('#CartTerms-Drawer').checked;
      } else if (cart) {
        termsAccepted = cart.querySelector('#CartTerms-Drawer').checked;
      }
      return termsAccepted;
    }
  }, {
    key: "closeAllPopovers",
    value: function closeAllPopovers() {
      var popovers = Array.from(this.customerPopover.querySelectorAll('.customer-popover-element'));
      popovers.forEach(function (popover) {
        popover.classList.remove('active');
      });
      // Ensure the overlay itself is removed as well.
      this.togglePopoverOverlay();
    }
  }, {
    key: "handleCheckoutButtonClicked",
    value: function () {
      var _handleCheckoutButtonClicked = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var cartDrawer, cart, termsAccepted;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.customerTypeSelected = sessionStorage.getItem('customerType') !== null && sessionStorage.getItem('customerType') !== 'null';
              cartDrawer = this.closest('cart-drawer');
              cart = this.closest('theme-cart');
              termsAccepted = false;
              if (cartDrawer) {
                termsAccepted = cartDrawer.querySelector('#CartTerms-Drawer').checked;
              } else if (cart) {
                termsAccepted = cart.querySelector('#CartTerms-Drawer').checked;
              }
              if (!termsAccepted) {
                _context2.n = 4;
                break;
              }
              if (!this.customerTypeSelected) {
                _context2.n = 3;
                break;
              }
              _context2.n = 1;
              return this.updateCartInfo();
            case 1:
              _context2.n = 2;
              return this.handleFormSubmit();
            case 2:
              _context2.n = 4;
              break;
            case 3:
              // Handle case where customer type is not selected
              this.togglePopoverOverlay();
              this.togglePopoverContent(this.customerPopoverSelection);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleCheckoutButtonClicked() {
        return _handleCheckoutButtonClicked.apply(this, arguments);
      }
      return handleCheckoutButtonClicked;
    }()
  }, {
    key: "updateCartInfo",
    value: function () {
      var _updateCartInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var customerData, formData, response, data, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              customerData = JSON.parse(sessionStorage.getItem('customerData'));
              formData = {
                attributes: _objectSpread({
                  'Customer Type': this.customerType,
                  email: '',
                  cvrNumber: '',
                  eanNumber: '',
                  'local-vat-id': '',
                  'vat-address': '',
                  'vat-company': ''
                }, customerData)
              };
              _context3.p = 1;
              _context3.n = 2;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 2:
              response = _context3.v;
              if (response.ok) {
                _context3.n = 3;
                break;
              }
              throw new Error(response.statusText);
            case 3:
              _context3.n = 4;
              return response.json();
            case 4:
              data = _context3.v;
              console.log('Cart updated successfully:', data);
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              // eslint-disable-next-line no-console
              console.error(_t);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 5]]);
      }));
      function updateCartInfo() {
        return _updateCartInfo.apply(this, arguments);
      }
      return updateCartInfo;
    }()
  }, {
    key: "handleEanSubmit",
    value: function handleEanSubmit() {
      var ean = this.eanInput.value;
      var errorMessageElement = this.eanInput.nextElementSibling;
      if (!errorMessageElement) {
        errorMessageElement = document.createElement('p');
        errorMessageElement.classList.add('tw-text-red-500', 'tw-text-xs', 'tw-mt-2', 'tw-hidden', 'tw-mb-0');
        this.eanInput.insertAdjacentElement('afterend', errorMessageElement);
      }
      var isValidEan = ean.match(/^[0-9]{13}$/);
      if (!isValidEan) {
        errorMessageElement.textContent = 'Indtast venligst et gyldigt EAN-nummer';
        errorMessageElement.classList.remove('tw-hidden');
        return;
      }
      errorMessageElement.classList.add('tw-hidden');
      // Clear the sessionStorage customerData and store new EAN
      sessionStorage.removeItem('customerData');
      sessionStorage.setItem('customerData', JSON.stringify({
        eanNumber: ean
      }));
      
      var _this = this;
      // Update cart with EAN information
      this.updateCartInfo().then(function() {
        _this.closeAllPopovers();
        // Only go to checkout if terms are accepted
        if (_this.checkTermsAccepted()) {
          window.location.href = '/checkout';
        }
      }).catch(function(error) {
        console.error('Failed to update cart:', error);
        _this.closeAllPopovers();
        if (_this.checkTermsAccepted()) {
          window.location.href = '/checkout';
        }
      });
    }
  }, {
    key: "handleCvrSubmit",
    value: function () {
      var _handleCvrSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var cvr, email, cvrErrorMessageElement, emailErrorMessageElement, cvrIsNotEmpty, isValidEmail, loader, textElement, response, data, _t;
        var _this3 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              cvr = this.cvrInput.value;
              email = this.emailInput.value;
              cvrErrorMessageElement = this.cvrInput.nextElementSibling;
              if (!cvrErrorMessageElement) {
                cvrErrorMessageElement = document.createElement('p');
                cvrErrorMessageElement.classList.add('tw-text-red-500', 'tw-text-xs', 'tw-mt-2', 'tw-hidden', 'tw-mb-0');
                this.cvrInput.insertAdjacentElement('afterend', cvrErrorMessageElement);
              }
              emailErrorMessageElement = this.emailInput.nextElementSibling;
              if (!emailErrorMessageElement) {
                emailErrorMessageElement = document.createElement('p');
                emailErrorMessageElement.classList.add('tw-text-red-500', 'tw-text-xs', 'tw-mt-2', 'tw-hidden', 'tw-mb-0');
                this.emailInput.insertAdjacentElement('afterend', emailErrorMessageElement);
              }
              cvrIsNotEmpty = cvr.length > 0;
              if (!cvrIsNotEmpty) {
                cvrErrorMessageElement.textContent = 'Indtast venligst et CVR-nummer';
                cvrErrorMessageElement.classList.remove('tw-hidden');
                return _context5.a(2);
              }
              isValidEmail = email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
              if (!isValidEmail) {
                emailErrorMessageElement.textContent = 'Indtast venligst en gyldig email-adresse';
                emailErrorMessageElement.classList.remove('tw-hidden');
                return _context5.a(2);
              }
              emailErrorMessageElement.classList.add('tw-hidden');
              loader = this.cvrSubmitButton.querySelector('.loader');
              textElement = this.cvrSubmitButton.querySelector('.text');
              loader.classList.toggle('tw-hidden');
              textElement.classList.toggle('tw-hidden');
              this.cvrSubmitButton.disabled = true;
              _context5.p = 1;
              _context5.n = 2;
              return fetch(`https://shopify-proxy-222804631241.europe-west1.run.app/proxy/anlacreative/vat/${cvr}`);
            case 2:
              response = _context5.v;
              _context5.n = 3;
              return response.json();
            case 3:
              data = _context5.v;
              if (data?.valid || data?.data?.valid) {
                cvrErrorMessageElement.classList.add('tw-hidden');
                loader.classList.toggle('tw-hidden');
                textElement.classList.toggle('tw-hidden');
                this.cvrSubmitButton.disabled = false;
                sessionStorage.removeItem('customerData');
                sessionStorage.setItem('customerData', JSON.stringify({
                  cvrNumber: cvr,
                  email: email,
                  'local-vat-id': cvr,
                  'vat-address': data.address,
                  'vat-company': data.name
                }));
                this.closeAllPopovers();
                _context5.p = 4;
                _context5.n = 5;
                return this.updateCartInfo();
              } else {
                if (data.error && data.error.detail === "Please include the country code prefix.") {
                  cvrErrorMessageElement.textContent = "Inkludér venligst landekode-præfikset (f.eks. DK foran CVR-nummeret).";
                } else {
                  cvrErrorMessageElement.textContent = data.message || (data.error && data.error.detail) || 'Ugyldigt CVR-nummer. Venligst kontrollér og prøv igen.';
                }
                cvrErrorMessageElement.classList.remove('tw-hidden');
                loader.classList.toggle('tw-hidden');
                textElement.classList.toggle('tw-hidden');
                this.cvrSubmitButton.disabled = false;
              }
              _context5.n = 6;
              break;
            case 4:
              _context5.p = 4;
              _t = _context5.v;
              cvrErrorMessageElement.textContent = 'Fejl ved validering af CVR-nummer. Venligst prøv igen.';
              cvrErrorMessageElement.classList.remove('tw-hidden');
              loader.classList.toggle('tw-hidden');
              textElement.classList.toggle('tw-hidden');
              this.cvrSubmitButton.disabled = false;
              console.error('CVR validation error:', _t);
              _context5.n = 6;
              break;
            case 5:
              // Cart update completed successfully, redirect to checkout only if terms accepted
              if (this.checkTermsAccepted()) {
                window.location.href = '/checkout';
              }
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 4]]);
      }));
      function handleCvrSubmit() {
        return _handleCvrSubmit.apply(this, arguments);
      }
      return handleCvrSubmit;
    }()
  }, {
    key: "handleCvrInputChange",
    value: function handleCvrInputChange(event) {
      // Get or create error message element
      var cvrErrorMessageElement = this.cvrInput.nextElementSibling;
      
      if (!cvrErrorMessageElement) {
        return;
      }

      // Simply clear the error message when customer starts typing
      cvrErrorMessageElement.classList.add('tw-hidden');
    }
  }, {
    key: "handleFormSubmit",
    value: function () {
      var _handleFormSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var customerType, eanNumber, cartTheme, cartDrawer, cvrNumber, email, cvrSubmitButton, _cartTheme, _cartDrawer;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              customerType = sessionStorage.getItem('customerType'); // In this scenario customerType is selected so we need to handle the three different customer types
              if (!(customerType === 'gov')) {
                _context4.n = 2;
                break;
              }
              // Check if we already have validated EAN data
              var existingCustomerData = sessionStorage.getItem('customerData');
              var hasValidatedEan = false;
              if (existingCustomerData) {
                var parsedData = JSON.parse(existingCustomerData);
                hasValidatedEan = parsedData.eanNumber;
              }
              
              if (hasValidatedEan) {
                // Already have validated EAN data, go directly to checkout
                window.location.href = '/checkout';
                return _context4.a(2);
              }
              
              eanNumber = this.eanInput.value.trim();
              if (eanNumber) {
                _context4.n = 1;
                break;
              }
              this.togglePopoverOverlay();
              this.togglePopoverContent(this.customerPopoverSelection);
              this.togglePopoverContent(this.customerPopoverGov);
              return _context4.a(2);
            case 1:
              cartTheme = this.closest('theme-cart');
              cartDrawer = this.closest('cart-drawer');
              if (cartTheme || cartDrawer) {
                window.location.href = '/checkout';
              }
              _context4.n = 3;
              break;
            case 2:
              if (customerType === 'b2b') {
                // Check if we already have validated CVR data
                var existingCustomerData = sessionStorage.getItem('customerData');
                var hasValidatedCvr = false;
                if (existingCustomerData) {
                  var parsedData = JSON.parse(existingCustomerData);
                  hasValidatedCvr = parsedData.cvrNumber && parsedData.email && parsedData['local-vat-id'];
                }
                
                if (hasValidatedCvr) {
                  // Already have validated CVR data, go directly to checkout
                  window.location.href = '/checkout';
                } else {
                  // Need to validate CVR
                  cvrNumber = this.cvrInput.value.trim();
                  email = this.emailInput.value.trim();
                  this.togglePopoverOverlay();
                  this.togglePopoverContent(this.customerPopoverSelection);
                  this.togglePopoverContent(this.customerPopoverB2b);
                  if (cvrNumber && email) {
                    cvrSubmitButton = this.cvrSubmitButton;
                    cvrSubmitButton.click();
                  }
                }
              } else if (customerType === 'b2c') {
                // For B2C, proceed directly to checkout
                _cartTheme = this.closest('theme-cart');
                _cartDrawer = this.closest('cart-drawer');
                this.togglePopoverOverlay();
                if (_cartTheme || _cartDrawer) {
                  window.location.href = '/checkout';
                }
              }
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleFormSubmit() {
        return _handleFormSubmit.apply(this, arguments);
      }
      return handleFormSubmit;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/*

export default class SelectCustomerType extends HTMLElement {
  cvrValidated: boolean = false;

  form: HTMLFormElement;

  checkoutButton: HTMLButtonElement;

  customerType: string;

  customerTypeSelected: boolean;

  customerPopover: HTMLElement;

  customerPopoverSelection: HTMLElement;

  customerPopoverB2b: HTMLElement;

  customerPopoverGov: HTMLElement;

  customerTypeButtons: HTMLAnchorElement[];

  changeCustomerTypeButton: HTMLAnchorElement;

  changeCustomerTypeButtonText: string;

  closePopoverButtons: HTMLAnchorElement[];

  eanSubmitButton: HTMLButtonElement;

  cvrSubmitButton: HTMLButtonElement;

  sessionStorageCustomerData: string;

  eanInput: HTMLInputElement;

  cvrInput: HTMLInputElement;

  emailInput: HTMLInputElement;

  customerCustomerType: string;

  customerCvrNumber: string;

  customerEanNumber: string;

  customerEmail: string;

  cartDrawer: HTMLElement;

  constructor() {
    super();
    this.initElements = this.initElements.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);
    this.togglePopoverOverlay = this.togglePopoverOverlay.bind(this);
    this.togglePopoverContent = this.togglePopoverContent.bind(this);
    this.handleCustomerTypeSelection = this.handleCustomerTypeSelection.bind(this);
    this.handleTogglePopoverContent = this.handleTogglePopoverContent.bind(this);
    this.handleCheckoutButtonClicked = this.handleCheckoutButtonClicked.bind(this);
    this.updateCartInfo = this.updateCartInfo.bind(this);
    this.handleEanSubmit = this.handleEanSubmit.bind(this);
    this.handleCvrSubmit = this.handleCvrSubmit.bind(this);
    this.closeAllPopovers = this.closeAllPopovers.bind(this);
    this.initData = this.initData.bind(this);
  }

  connectedCallback() {
    this.initData();
    this.initElements();
    this.addEventListeners();

    if (this.customerTypeSelected) {
      this.changeCustomerTypeButton.classList.remove('tw-hidden');
      this.changeCustomerTypeButton.textContent = `${this.changeCustomerTypeButtonText} (${this.customerType})`;
    }
  }

  initData(): void {
    this.customerCustomerType = this.dataset.customertype || null;
    this.customerCvrNumber = this.dataset.cvrnumber || null;
    this.customerEanNumber = this.dataset.eannumber || null;
    this.customerEmail = this.dataset.email || null;

    if (this.customerCvrNumber || this.customerEanNumber || this.customerEmail) {
      sessionStorage.setItem('customerType', this.customerCustomerType);
      sessionStorage.setItem(
        'customerData',
        JSON.stringify({
          cvrNumber: this.customerCvrNumber,
          eanNumber: this.customerEanNumber,
          email: this.customerEmail,
        })
      );
    }

    this.customerType = sessionStorage.getItem('customerType') || null;
    this.customerTypeSelected = this.customerType !== null;

    this.sessionStorageCustomerData = sessionStorage.getItem('customerData') || null;
  }

  initElements(): void {
    this.form = this.querySelector('form');
    this.checkoutButton = this.form.querySelector('button[type="submit"]');
    this.customerPopover = document.getElementById('customer-type-popover');
    this.customerPopoverSelection = this.customerPopover.querySelector('#customer-type-popover-content');
    this.customerTypeButtons = Array.from(this.customerPopover.querySelectorAll('.customer-type-button'));
    this.changeCustomerTypeButton = this.querySelector('#change-customer-type');
    this.changeCustomerTypeButtonText = this.changeCustomerTypeButton.textContent;
    this.customerPopoverB2b = this.customerPopover.querySelector('#customer-type-popover-b2b');
    this.customerPopoverGov = this.customerPopover.querySelector('#customer-type-popover-gov');

    this.closePopoverButtons = Array.from(this.customerPopover.querySelectorAll('.close-popover'));

    // Ean elements - goverment
    this.eanSubmitButton = this.customerPopover.querySelector('#ean-submit');
    this.eanInput = this.customerPopover.querySelector('#ean-input');

    const existingCustomerData = this.sessionStorageCustomerData ? JSON.parse(this.sessionStorageCustomerData) : {};
    if (existingCustomerData.eanNumber) {
      this.eanInput.value = existingCustomerData.eanNumber;
    }

    // cvr+ email - b2b
    this.cvrSubmitButton = this.customerPopover.querySelector('#cvr-submit');
    this.cvrInput = this.customerPopover.querySelector('#cvr-input');
    this.emailInput = this.customerPopover.querySelector('#email-input');

    if (existingCustomerData.cvrNumber) {
      this.cvrInput.value = existingCustomerData.cvrNumber;
    }

    if (existingCustomerData.email) {
      this.emailInput.value = existingCustomerData.email;
    }
  }

  addEventListeners(): void {
    this.checkoutButton.addEventListener('click', async (event: MouseEvent | TouchEvent) => {
      event.preventDefault();
      await this.handleCheckoutButtonClicked();
    });

    this.customerTypeButtons.forEach((button) => {
      button.addEventListener('click', (event: MouseEvent | TouchEvent) => {
        event.preventDefault();
        this.handleCustomerTypeSelection(button);
      });
    });

    this.changeCustomerTypeButton.addEventListener('click', (event: MouseEvent | TouchEvent) => {
      event.preventDefault();
      this.togglePopoverOverlay();
      this.togglePopoverContent(this.customerPopoverSelection);
    });

    this.closePopoverButtons.forEach((button) => {
      button.addEventListener('click', (event: MouseEvent | TouchEvent) => {
        event.preventDefault();
        this.handleTogglePopoverContent();
      });
    });

    this.eanSubmitButton.addEventListener('click', (event: MouseEvent | TouchEvent) => {
      event.preventDefault();
      this.handleEanSubmit();
    });

    this.cvrSubmitButton.addEventListener('click', async (event: MouseEvent | TouchEvent) => {
      event.preventDefault();
      await this.handleCvrSubmit();
    });
  }

  togglePopoverOverlay(): void {
    this.customerPopover.classList.toggle('active');
  }

  // eslint-disable-next-line class-methods-use-this
  togglePopoverContent(popoverElement: HTMLElement): void {
    setTimeout(() => {
      popoverElement.classList.toggle('active');
    }, 100);
  }

  handleCustomerTypeSelection(button: HTMLAnchorElement): void {
    this.customerType = button.dataset.option;
    sessionStorage.setItem('customerType', this.customerType);
    this.changeCustomerTypeButton.classList.remove('tw-hidden');

    this.togglePopoverContent(this.customerPopoverSelection);
    if (this.customerType === 'b2b') {
      this.togglePopoverContent(this.customerPopoverB2b);
    } else if (this.customerType === 'gov') {
      this.togglePopoverContent(this.customerPopoverGov);
    } else {
      sessionStorage.removeItem('customerData');
      this.togglePopoverOverlay();
    }

    this.changeCustomerTypeButton.textContent = `${this.changeCustomerTypeButtonText} (${this.customerType})`;
  }

  handleTogglePopoverContent(): void {
    const activePopover = this.customerPopover.querySelector('.customer-popover-element.active');
    const selectionPopoverIsOpen = this.customerPopoverSelection.classList.contains('active');
    const b2bPopoverIsOpen = this.customerPopoverB2b.classList.contains('active');
    const govPopoverIsOpen = this.customerPopoverGov.classList.contains('active');

    if (selectionPopoverIsOpen) {
      this.togglePopoverOverlay();
    }

    if (b2bPopoverIsOpen || govPopoverIsOpen) {
      this.togglePopoverContent(this.customerPopoverSelection);
    }

    activePopover.classList.remove('active');
  }

  async handleCheckoutButtonClicked(): Promise<void> {
    this.customerTypeSelected = sessionStorage.getItem('customerType') !== null;
    const cartDrawer = this.closest('cart-drawer');
    const termsAccepted = (cartDrawer.querySelector('#CartTerms-Drawer') as HTMLInputElement).checked;
    if (termsAccepted) {
      if (!this.customerTypeSelected) {
        this.togglePopoverOverlay();
        this.togglePopoverContent(this.customerPopoverSelection);
      } else {
        await this.updateCartInfo();
        await this.handleFormSubmit();
      }
    }
  }

  async updateCartInfo(): Promise<void> {
    const customerData = JSON.parse(sessionStorage.getItem('customerData'));

    const formData = {
      attributes: {
        'Customer Type': this.customerType,
        email: '',
        cvrNumber: '',
        eanNumber: '',
        ...customerData,
      },
    };

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const data = await response.json();
      console.log('Cart updated successfully:', data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  handleEanSubmit(): void {
    const ean = this.eanInput.value;

    let errorMessageElement = this.eanInput.nextElementSibling;
    if (!errorMessageElement) {
      errorMessageElement = document.createElement('p');
      errorMessageElement.classList.add('tw-text-red-500', 'tw-text-xs', 'tw-mt-2', 'tw-hidden', 'tw-mb-0');
      this.eanInput.insertAdjacentElement('afterend', errorMessageElement);
    }

    const isValidEan = ean.match(/^[0-9]{13}$/);
    if (!isValidEan) {
      errorMessageElement.textContent = 'Please enter a valid EAN number';
      errorMessageElement.classList.remove('tw-hidden');
      return;
    }

    errorMessageElement.classList.add('tw-hidden');

    // clear the sessionStorage customerData
    sessionStorage.removeItem('customerData');
    sessionStorage.setItem('customerData', JSON.stringify({ eanNumber: ean }));
    this.closeAllPopovers();
  }

  async handleCvrSubmit(): Promise<void> {
    const cvr = this.cvrInput.value;
    const email = this.emailInput.value;

    let cvrErrorMessageElement = this.cvrInput.nextElementSibling;
    if (!cvrErrorMessageElement) {
      cvrErrorMessageElement = document.createElement('p');
      cvrErrorMessageElement.classList.add('tw-text-red-500', 'tw-text-xs', 'tw-mt-2', 'tw-hidden', 'tw-mb-0');
      this.cvrInput.insertAdjacentElement('afterend', cvrErrorMessageElement);
    }

    let emailErrorMessageElement = this.emailInput.nextElementSibling;
    if (!emailErrorMessageElement) {
      emailErrorMessageElement = document.createElement('p');
      emailErrorMessageElement.classList.add('tw-text-red-500', 'tw-text-xs', 'tw-mt-2', 'tw-hidden', 'tw-mb-0');
      this.emailInput.insertAdjacentElement('afterend', emailErrorMessageElement);
    }

    const cvrIsNotEmpty = cvr.length > 0;
    if (!cvrIsNotEmpty) {
      cvrErrorMessageElement.textContent = 'Please enter a CVR number';
      cvrErrorMessageElement.classList.remove('tw-hidden');
      return;
    }

    // regex for valid email
    const isValidEmail = email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    if (!isValidEmail) {
      emailErrorMessageElement.textContent = 'Please enter a valid email address';
      emailErrorMessageElement.classList.remove('tw-hidden');
      return;
    }

    emailErrorMessageElement.classList.add('tw-hidden');

    const loader = this.cvrSubmitButton.querySelector('.loader') as HTMLElement;
    const textElement = this.cvrSubmitButton.querySelector('.text') as HTMLElement;

    loader.classList.toggle('tw-hidden');
    textElement.classList.toggle('tw-hidden');
    this.cvrSubmitButton.disabled = true;

    const countryCode = cvr.slice(0, 2).toUpperCase();
    const vatNumber = cvr.slice(2);

    try {
      const response = await fetch(`https://ec.europa.eu/taxation_customs/vies/rest-api/ms/${countryCode}/vat/${vatNumber}`);

      console.log('Response status:', response);

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const data = await response.json();
      console.log('CVR submitted successfully:', data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error submitting CVR:', error);
      cvrErrorMessageElement.textContent = 'An error occurred while submitting the CVR number';
      cvrErrorMessageElement.classList.remove('tw-hidden');
      this.cvrSubmitButton.disabled = false;
      loader.classList.toggle('tw-hidden');
      textElement.classList.toggle('tw-hidden');
    }
  }

  closeAllPopovers(): void {
    const popovers = Array.from(this.customerPopover.querySelectorAll('.customer-popover-element')) as HTMLElement[];
    popovers.forEach((popover) => {
      popover.classList.remove('active');
    });

    this.togglePopoverOverlay();
  }

  async handleFormSubmit(): Promise<void> {
    const customerType = sessionStorage.getItem('customerType');
    // In this scenario customerType is selected so we need to handle the three different customer types
    if (customerType === 'gov') {
      // Check if eaanNumber is set in the field
      const eanNumber = this.eanInput.value.trim();
      if (!eanNumber) {
        this.togglePopoverOverlay();
        this.togglePopoverContent(this.customerPopoverSelection);
        this.togglePopoverContent(this.customerPopoverGov);
        return;
      }

      window.location.href = '/checkout';
    } else if (customerType === 'b2b') {
      const cvrNumber = this.cvrInput.value.trim();
      const email = this.emailInput.value.trim();
      this.togglePopoverOverlay();
      this.togglePopoverContent(this.customerPopoverSelection);
      this.togglePopoverContent(this.customerPopoverB2b);
      if (cvrNumber && email) {
        const cvrSubmitButton = this.cvrSubmitButton as HTMLButtonElement;
        cvrSubmitButton.click();
      }
    } else if (customerType === 'b2c') {
      // dispatch the form submit event
      window.location.href = '/checkout';
    }
  }
}
*/


/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "countryData", void 0);
    _defineProperty(_this, "url", window.location.href);
    _this.countryData = window.countryData;
    // bind the methods to the class
    _this.getSelectedCountry = _this.getSelectedCountry.bind(_this);
    _this.getVisitorCountry = _this.getVisitorCountry.bind(_this);
    _this.showGeoPopup = _this.showGeoPopup.bind(_this);
    _this.handleClickedStayButton = _this.handleClickedStayButton.bind(_this);
    _this.handleClickedRedirectButton = _this.handleClickedRedirectButton.bind(_this);
    _this.checkUrlForParam = _this.checkUrlForParam.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var editionGeoCookie, editionGeoSwitchCookie, _window, countryData, selectedCountry, visitorCountry, visitorCountryIsInCountryData, primaryCountryDataInCountryData, visitorCountryDataInCountryData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.checkUrlForParam();
              editionGeoCookie = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geocookie');
              editionGeoSwitchCookie = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geoswitch');
              if (!(editionGeoCookie || editionGeoSwitchCookie || Shopify.designMode === true)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _window = window, countryData = _window.countryData;
              selectedCountry = this.getSelectedCountry();
              _context.n = 2;
              return this.getVisitorCountry();
            case 2:
              visitorCountry = _context.v;
              if (!(selectedCountry.countryCode === visitorCountry.handle)) {
                _context.n = 3;
                break;
              }
              _context.n = 6;
              break;
            case 3:
              visitorCountryIsInCountryData = countryData.some(function (country) {
                return country.countryCode === visitorCountry.handle;
              });
              console.log(visitorCountryIsInCountryData, 'visitorCountryIsInCountryData');
              if (visitorCountryIsInCountryData) {
                _context.n = 5;
                break;
              }
              primaryCountryDataInCountryData = countryData.find(function (country) {
                return country.primaryCountry === true;
              });
              if (!(selectedCountry.countryCode === primaryCountryDataInCountryData.countryCode)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              console.log(primaryCountryDataInCountryData, 'primaryCountryDataInCountryData');
              this.showGeoPopup(primaryCountryDataInCountryData);
              _context.n = 6;
              break;
            case 5:
              visitorCountryDataInCountryData = countryData.find(function (country) {
                return country.countryCode === visitorCountry.handle;
              });
              this.showGeoPopup(visitorCountryDataInCountryData);
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "getSelectedCountry",
    value: function getSelectedCountry() {
      var countryDataArray = this.countryData;
      var selectedCountry = countryDataArray.find(function (country) {
        return country.locale === Shopify.locale;
      });
      return selectedCountry;
    }
  }, {
    key: "getVisitorCountry",
    value: function () {
      var _getVisitorCountry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, visitorCountry;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/browsing_context_suggestions.json');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              visitorCountry = data.detected_values.country;
              this.setAttribute('data-visitor-country', visitorCountry.handle);
              return _context2.a(2, visitorCountry);
          }
        }, _callee2, this);
      }));
      function getVisitorCountry() {
        return _getVisitorCountry.apply(this, arguments);
      }
      return getVisitorCountry;
    }()
  }, {
    key: "showGeoPopup",
    value: function showGeoPopup(countryObject) {
      var _this2 = this;
      this.classList.remove('tw-z-[-1]');
      this.classList.add('tw-z-[100]');
      setTimeout(function () {
        _this2.classList.add('!tw-opacity-100');
      }, 500);
      var layout = this.dataset.layout;
      if (layout === 'primary') {
        var img = this.querySelector('#geolocator-flag');
        var heading = this.querySelector('#geolocator-heading');
        var richtext = this.querySelector('#geolocator-richtext');
        var buttonRedirect = this.querySelector('#geolocator-button-redirect');
        var buttonStay = this.querySelector('#geolocator-button-stay');
        if (img) {
          img.src = countryObject.flag;
        }
        heading.innerHTML = countryObject.heading;
        richtext.innerText = countryObject.richtext;
        buttonRedirect.innerHTML = countryObject.button_one;
        buttonStay.innerHTML = countryObject.button_two;
        // If the user clicks the "redirect" button, redirect to the selected country or market
        buttonRedirect.addEventListener('click', this.handleClickedRedirectButton.bind(this, countryObject));
        // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
        buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
      } else {
        var _heading = this.querySelector('#geolocator-heading');
        var _richtext = this.querySelector('#geolocator-richtext');
        var _buttonStay = this.querySelector('#geolocator-button-stay');
        this.SortAndOrderCountries(countryObject);
        _heading.innerHTML = countryObject.heading;
        _richtext.innerHTML = countryObject.richtext;
        _buttonStay.innerHTML = countryObject.button_two;
        // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
        _buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
      }
    }
  }, {
    key: "handleClickedStayButton",
    value: function handleClickedStayButton() {
      var _this3 = this;
      this.classList.remove('tw-opacity-100');
      this.classList.add('tw-opacity-0');
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geocookie', 'true', 10);
      setTimeout(function () {
        _this3.remove();
      }, 1000);
    }
  }, {
    key: "handleClickedRedirectButton",
    value: function handleClickedRedirectButton(countryObject) {
      this.remove();
      var storeType = countryObject.type;
      if (storeType === 'Country') {
        var redirectUrl = countryObject.link;
        window.location.href = redirectUrl;
      } else if (storeType === 'Market') {
        var code = countryObject.countryCode;
        var countryLocale = countryObject.locale;
        this.updateLocalization(code, countryLocale);
      }
    }
  }, {
    key: "checkUrlForParam",
    value: function checkUrlForParam() {
      if (this.url.includes('?edition-geoswitch')) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geoswitch', 'true', 10);
      }
    }
  }, {
    key: "SortAndOrderCountries",
    value: function SortAndOrderCountries(countryObject) {
      var currentCountryListHolder = this.querySelector('#geolocator-country-list');
      var currentCountryList = Array.from(currentCountryListHolder.querySelectorAll('.geolocator_country'));
      // Each geolocator_country has a data-locale attribute. Sort the currentCountryList based on the data-locale attribute so the country that has the same locale as the countryObject is first in the list
      currentCountryList.sort(function (a, b) {
        if (a.dataset.locale === countryObject.locale) {
          return -1;
        }
        if (b.dataset.locale === countryObject.locale) {
          return 1;
        }
        return 0;
      });
      // Add the sorted list back to the DOM
      currentCountryList.forEach(function (country) {
        currentCountryListHolder.appendChild(country);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateLocalization",
    value: function updateLocalization(countryCode, countryLocale) {
      var randomFormId = Math.random().toString(36).substring(7);
      var formHtml = "\n    <form id=\"".concat(randomFormId, "\" action=\"/localization\" method=\"POST\" hidden>\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"").concat(countryCode, "\">\n      <input name=\"language_code\" value=\"").concat(countryLocale, "\">\n    </form>\n  ");
      document.body.insertAdjacentHTML('beforeend', formHtml);
      var form = document.getElementById(randomFormId);
      form.submit();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deleteCookie: () => (/* binding */ deleteCookie),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/src/assets/app": 0,
/******/ 			"src/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkanla_creative"] = self["webpackChunkanla_creative"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;